import axiosInstance from './axiosInstance';

const getBooks = async ({input, onSuccess}) => {
  try {
    const response = await axiosInstance.post(
      '/books',
      {},
      {
        headers: {
          Authorization: input.token,
        },
      }
    );
    onSuccess(response.data);
    return response.data;
  } catch (error) {
    throw new Error('Error posting data: ' + error.message);
  }
};

export {getBooks};